import React from "react";
import { useTranslation } from "react-i18next";

import { useTaskRemoval } from "@planzone/view-models";
import { CloseIcon } from "@common/assets/closeIcon";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { TaskDetails } from "./taskDetails";
import { Props } from "./types";
import styles from "./styles.scss";

function TaskRemoval({ task, cancel }: Props) {
  const { t } = useTranslation();
  const { removeTask, isRequestPending } = useTaskRemoval(task);

  return (
    <Modal
      header={t("removeTask.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeTask.warning")}</p>
          <div className={styles.details}>
            <TaskDetails task={task} />
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeTask.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeTask(task)}
          >
            {t("removeTask.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { TaskRemoval };
